// extracted by mini-css-extract-plugin
export default {"container":"desktop_container__kvCrD"};